
















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import FormLayout from '../FormLayout.vue';

import BaseSelect from '@/components/select/BaseSelect.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';
import DatepickerPopup from '@/components/datepicker/DatepickerPopup.vue';
import ScheduleDayList from './ScheduleDayList.vue';

import { getTodayDate, getMonthFromDate } from '@/utils/date';

import { typeItems } from './const';

import { ScheduleSetForm } from './types';

import { SelectItem, SelectValue } from '@/components/select/types';
import { ISODateRange, ISOCalendarDate } from '@/utils/date/types';

@Component({
    components: {
        FormLayout,
        BaseSelect,
        DatepickerPopup,
        ScheduleDayList,
        BaseButton,
    },
})
export default class FormScheduleSet extends Vue {
    @Prop({ required: true }) date!: ISOCalendarDate
    @Prop({ default: () => [] }) clinics!: SelectItem[]

    form: ScheduleSetForm = {
        type: null,
        from: '',
        to: '',
        schedule: [],
    }

    mainClinic: SelectValue = null

    get month() {
        return getMonthFromDate(this.date);
    }

    get minFromDate() {
        return getTodayDate();
    }

    get minToDate() {
        return this.form.from || this.minFromDate;
    }

    get typeItems() {
        return typeItems;
    }

    get canSubmit() {
        if (this.form.type === null) {
            return false;   
        }

        return true;
    }

    get isSettingSchedule() {
        return this.form.type?.id === 'schedule';
    }

    updateSchedule() {
        if (this.isSettingSchedule) {
            this.$emit('schedule:clinic', this.form);
            return;
        }

        const dates: ISODateRange = {
            start: this.form.from,
            end: this.form.to,            
        }
        this.$emit('create:vacation', dates);
    }
    
    closeForm() {
        this.$emit('schedule:cancel');
    }
}
